import { Button, Row, Col, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { createAwardtype } from "../../../../services/AwardtypeService";
import { getAwardceremony } from "../../../../services/AwardceremonyService";
import { useEffect, useState } from "react";
const validationSchema = Yup.object().shape({
  label: Yup.string().required("Required"),
  amount: Yup.string().required("Required"),
  value: Yup.string().required("Required"),
  type: Yup.string().required("Required"),
  description: Yup.string().required("Required"),
  quater: Yup.string().required("Required"),
  isSubsequent: Yup.boolean().default(false),
  subsequentAmount: Yup.string().default("0"),
  showSpotBonus: Yup.boolean().default(false),
});

const AddAwardtypeForm = () => {
  const initialValues = {
    label: "",
    amount: "",
    value: "",
    type: "",
    description: "",
    quater: "",
    isSubsequent: false,
    subsequentAmount: "0",
    showSpotBonus: false,
  };

  const navigate = useNavigate();
  const [awardceremony, setAwardceremony] = useState([]);

  useEffect(() => {
    fetchAwardceremony();
  }, []);

  const fetchAwardceremony = async () => {
    try {
      const data = await getAwardceremony();
      setAwardceremony(data);
    } catch (error) {
      console.error("Error fetching awardceremony:", error);
    }
  };

  const handleSubmit = async (values) => {
    // Send the form data to the server
    try {
      await createAwardtype(values);
      // Show success toast notification
      toast.success("Awardtype added Successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000, // Closes after 3 seconds
      });
      // Delay navigation to ensure toast is visible
      setTimeout(() => {
        navigate("/settings/awardtypes");
      }, 3000);
      console.log("Awardtype added successfully");

      // Optionally, redirect or update state after successful add
    } catch (error) {
      console.error("Error adding awardtype:", error);
      toast.error("Failed to adding Award Type!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
      });
    }
  };

  return (
    <>
      <Card>
        <div className="card-body">
          <Row>
            <Col md={12}>
              <h4>Add Award Type</h4>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                  <Form id="AwardTypeForm">
                    <Row className="mt-3 mb-3">
                      <Col md={3}>
                        <div controlId="label">
                          <label>Label</label>
                          <Field
                            type="text"
                            name="label"
                            className="form-control"
                            placeholder="Label"
                          />
                          {errors.label && touched.label && (
                            <div className="text-danger">{errors.label}</div>
                          )}
                        </div>
                      </Col>
                      <Col md={3}>
                        <div controlId="value">
                          <label>Value</label>
                          <Field
                            type="text"
                            name="value"
                            className="form-control"
                            placeholder="value"
                          />
                          {errors.value && touched.value && (
                            <div className="text-danger">{errors.value}</div>
                          )}
                        </div>
                      </Col>
                      <Col md={3}>
                        <div controlId="amount">
                          <label>Amount</label>
                          <Field
                            type="text"
                            name="amount"
                            className="form-control"
                            placeholder="Number"
                          />
                          {errors.amount && touched.amount && (
                            <div className="text-danger">{errors.amount}</div>
                          )}
                        </div>
                      </Col>
                      <Col md={3}>
                        <div controlId="value">
                          <label>Type</label>
                          <Select
                            name="type"
                            options={[
                              { value: "normal", label: "Normal" },
                              { value: "spot", label: "Spot" },
                            ]}
                            placeholder="Select Award type..."
                            className={`react-select-container`}
                            classNamePrefix="react-select"
                            onChange={(option) => {
                              setFieldValue("type", option.value);
                            }}
                          />
                          {errors.type && touched.type && (
                            <div className="text-danger">{errors.type}</div>
                          )}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={3}>
                        <div controlId="description">
                          <label>Description</label>
                          <Field
                            type="text"
                            name="description"
                            className="form-control"
                            placeholder="text"
                          />
                          {errors.description && touched.description && (
                            <div className="text-danger">
                              {errors.description}
                            </div>
                          )}
                        </div>
                      </Col>
                      <Col md={2}>
                        <div controlId="quater">
                          <label>Quater</label>
                          <Select
                            name="quater"
                            options={awardceremony}
                            placeholder="Select Award Ceremony Quater..."
                            className={`react-select-container`}
                            classNamePrefix="react-select"
                            onChange={(option) => {
                              setFieldValue("quater", option.value);
                            }}
                          />
                          {errors.quater && touched.quater && (
                            <div className="text-danger">{errors.quater}</div>
                          )}
                        </div>
                      </Col>
                      <Col ms={3}>
                        <div controlId="showSpotBonus">
                          <label>Show Spot Bonus</label>
                          <Select
                            name="showSpotBonus"
                            options={[
                              { value: false, label: "No" },
                              { value: true, label: "Yes" },
                            ]}
                            placeholder="Select Spot Bonus..."
                            className={`react-select-container`}
                            classNamePrefix="react-select"
                            defaultValue={[
                              { value: false, label: "No" },
                              { value: true, label: "Yes" },
                            ].filter((e) => e.value == false)}
                            onChange={(option) => {
                              setFieldValue("showSpotBonus", option.value);
                            }}
                          />
                          {errors.showSpotBonus && touched.showSpotBonus && (
                            <div className="text-danger">
                              {errors.showSpotBonus}
                            </div>
                          )}
                        </div>
                      </Col>

                      <Col ms={2}>
                        <div className="form-group">
                          <label>
                            <Field
                              type="checkbox"
                              name="isSubsequent"
                              className="form-check-input"
                              style={{ marginRight: "10px" }}
                              onChange={(e) =>
                                setFieldValue("isSubsequent", e.target.checked)
                              }
                            />
                            is subsequent
                          </label>
                          {errors.isSubsequent && touched.isSubsequent && (
                            <div className="text-danger">
                              {errors.isSubsequent}
                            </div>
                          )}
                        </div>
                      </Col>

                      {values.isSubsequent && (
                        <Col ms={2}>
                          <div className="form-group">
                            <label>Subsequent Amount</label>
                            <Field
                              type="text"
                              name="subsequentAmount"
                              className="form-control"
                              placeholder="Enter Subsequent Amount"
                              defaultValue={"0"}
                            />
                            {errors.subsequentAmount &&
                              touched.subsequentAmount && (
                                <div className="text-danger">
                                  {errors.subsequentAmount}
                                </div>
                              )}
                          </div>
                        </Col>
                      )}
                    </Row>
                    <Row>
                      <Col md={12}>
                        <Button
                          style={{ background: "#3a7afe" }}
                          variant="primary"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          <i className="ti-save-alt" /> Save
                        </Button>
                        <Button
                          style={{
                            background: "#f25767",
                            border: "0px",
                            margin: "0.5rem",
                          }}
                          variant="warning"
                          href="/settings/awardtypes"
                        >
                          <i className="fa fa-trash"></i>
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>
        </div>
        <ToastContainer />
      </Card>
    </>
  );
};

export default AddAwardtypeForm;
